const mixin = {
	props: ['value', 'type', 'name', 'label', 'id', 'required', 'icon', 'props', 'formId', 'count'],
};

export default mixin;